(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warranty-claim-form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const warrantyForm = document.querySelector('.warranty-wrapper form');
  const orderRow = document.getElementById('orderRow');
  const hasOrder = document.getElementById('hasOrder');
  const orderInput = document.getElementById('orderInput');

  const otherRow = document.getElementById('otherRow');
  const otherRadio = document.getElementById('otherRadio');
  const otherInput = document.getElementById('otherInput');

  const purchaseRadios = document.querySelectorAll('input[name="contact[purchase_source]"]');

  function enableOrderField() {
    hasOrder.checked = true;
    orderInput.disabled = false;
  }

  function setOrderState(enabled) {
    orderInput.disabled = !enabled;
    if (!enabled) {
      orderInput.value = '';
      orderInput.setCustomValidity('');
    }
  }

  function setOtherState(enabled) {
    otherInput.disabled = !enabled;
    if (!enabled) {
      otherInput.value = '';
      otherInput.setCustomValidity('');
    }
  }

  // Initial state
  if (hasOrder && orderInput) {
    setOrderState(hasOrder.checked);
  }

  if (otherRadio && otherInput) {
    setOtherState(otherRadio.checked);
  }

  // Order Number row behavior
  if (orderRow && hasOrder && orderInput) {
    orderRow.addEventListener('click', function (event) {
      if (event.target !== orderInput) {
        enableOrderField();
        orderInput.focus();
      }
    });

    hasOrder.addEventListener('change', function () {
      setOrderState(hasOrder.checked);
      if (hasOrder.checked) {
        orderInput.focus();
      }
    });
  }

  // Other purchase source behavior
  if (otherRow && otherRadio && otherInput) {
    otherRow.addEventListener('click', function (event) {
      if (event.target !== otherInput) {
        otherRadio.checked = true;
        setOtherState(true);
        otherInput.focus();
      }
    });
  }

  purchaseRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      setOtherState(this.value === 'Other');
    });
  });

  // Final submit validation
  if (warrantyForm) {
    warrantyForm.addEventListener('submit', function (event) {
      let isValid = true;

      if (hasOrder && hasOrder.checked && orderInput && !orderInput.value.trim()) {
        orderInput.setCustomValidity('Please enter your order number.');
        orderInput.reportValidity();
        isValid = false;
      } else if (orderInput) {
        orderInput.setCustomValidity('');
      }

      if (otherRadio && otherRadio.checked && otherInput && !otherInput.value.trim()) {
        otherInput.setCustomValidity('Please enter the retailer name.');
        otherInput.reportValidity();
        isValid = false;
      } else if (otherInput) {
        otherInput.setCustomValidity('');
      }

      if (!isValid) {
        event.preventDefault();
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
